import React, { ReactElement } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { Sticker } from "web/react/emo/sticker";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./no-orders.css";

export function NoOrders(): ReactElement {
    return (
        <View padding="lg">
            <VStack spacing="md" align="center">
                <SVGIcon name="shopping-basket" className={styles.icon} />
                <VStack spacing="sm" align="center">
                    <Text as="p" textStyle="hero-s">
                        {gettext("order_history.no_orders.title")}
                    </Text>
                    <VStack spacing="none" align="center">
                        <Text as="p" textStyle="body-s">
                            {gettext("order_history.no_orders.description1")}
                        </Text>
                        <Text as="p" textStyle="body-s">
                            {gettext("order_history.no_orders.description2")}
                        </Text>
                    </VStack>
                    <Text as="p" textStyle="body-s">
                        {gettext("order_history.no_orders.description3")}
                    </Text>
                    <Sticker name="lystShopPartner" />
                </VStack>
            </VStack>
        </View>
    );
}
